"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequestFullQA = void 0;
const react_1 = require("react");
const graphql_1 = require("../../../../__generated__/graphql");
const cache_1 = require("../client/cache");
const use_task_details_hook_1 = require("../client/hooks/use-task-details.hook");
const use_update_priority_task_hook_1 = require("../../../client/priority-task/hooks/use-update-priority-task.hook");
const context_1 = require("../../../context");
const hooks_1 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const store_1 = require("../../../../store");
const useRequestFullQA = ({ nodeTitle, attributeName, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addError } = (0, hooks_1.useNotification)();
    const { isNodeOrRelatedNodeReEnriching } = (0, context_1.useCatalogActivityProgressContext)();
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const productTreeId = (0, store_1.useProductTreeId)();
    const { updatePriorityTask, loading } = (0, use_update_priority_task_hook_1.useUpdatePriorityTask)();
    const { isEscalated, escalationReason, instructions, productTreeNodeId, productLabelValidationId, queryVariables, isLoading, refetch, } = (0, use_task_details_hook_1.useTaskDetails)({ nodeTitle, attributeName });
    const toggleRequestFullQA = (0, react_1.useCallback)((nextEscalated, escalationReasonInput) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!catalogId || !productTreeId || !productTreeNodeId || !productLabelValidationId || !queryVariables) {
            addError(t({ key: 'GENERAL_ERROR_MESSAGE' }));
            return false;
        }
        const nextStatus = nextEscalated ? graphql_1.PriorityTaskStatus.Escalated : graphql_1.PriorityTaskStatus.InProgress;
        const nextEscalationReason = nextEscalated
            ? (escalationReasonInput !== null && escalationReasonInput !== void 0 ? escalationReasonInput : '').trim()
            : (escalationReason !== null && escalationReason !== void 0 ? escalationReason : null);
        try {
            const result = yield updatePriorityTask({
                catalog: catalogId,
                productTreeId,
                productTreeNodeId,
                productLabelValidationId,
                clientMutationId: '',
                status: nextStatus,
                escalationReason: nextEscalationReason,
            }, {
                optimisticResponse: {
                    updatePriorityTask: {
                        success: true,
                        error: null,
                        instructions: instructions !== null && instructions !== void 0 ? instructions : null,
                        status: nextStatus,
                        instructionsUpdatedAt: null,
                        assignedTo: null,
                        clientMutationId: '',
                        dateAssigned: null,
                        taskCount: null,
                        target: null,
                        priority: null,
                        escalationReason: nextEscalationReason,
                    },
                },
                update: (cache, { data }) => {
                    var _a, _b, _c, _d, _e;
                    if (!((_a = data === null || data === void 0 ? void 0 : data.updatePriorityTask) === null || _a === void 0 ? void 0 : _a.success)) {
                        return;
                    }
                    (0, cache_1.updateHLQATaskDetailsInCache)(cache, queryVariables, {
                        status: (_c = (_b = data.updatePriorityTask) === null || _b === void 0 ? void 0 : _b.status) !== null && _c !== void 0 ? _c : nextStatus,
                        escalationReason: (_e = (_d = data.updatePriorityTask) === null || _d === void 0 ? void 0 : _d.escalationReason) !== null && _e !== void 0 ? _e : nextEscalationReason,
                    });
                },
            });
            if (!((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.updatePriorityTask) === null || _b === void 0 ? void 0 : _b.success)) {
                throw new Error('Unable to update task escalation status');
            }
            yield refetch();
            return true;
        }
        catch (_c) {
            addError(t({ key: 'HLQA_REQUEST_FULL_QA_ERROR_MESSAGE' }));
            return false;
        }
    }), [
        addError,
        catalogId,
        escalationReason,
        instructions,
        productLabelValidationId,
        productTreeId,
        productTreeNodeId,
        queryVariables,
        refetch,
        t,
        updatePriorityTask,
    ]);
    const isCurrentNodeReEnriching = !!productTreeNodeId && isNodeOrRelatedNodeReEnriching(productTreeNodeId);
    const isRequestFullQaAllowed = !isCurrentNodeReEnriching
        && !loading
        && !isLoading
        && !!productTreeNodeId
        && !!productLabelValidationId
        && !!catalogId
        && !!productTreeId
        && !!queryVariables;
    return {
        isEscalated,
        toggleRequestFullQA,
        isLoading: loading,
        isRequestFullQaAllowed,
    };
};
exports.useRequestFullQA = useRequestFullQA;
